import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Tab from '../../../../components/tabs/';
import AnswerList from './answerList/';
import DyNewsList from '../../../../components/dyNewsList';

class Answer extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        
        const { niuRenJiePan } = content;

        const title = {
            id: '20047',
            type: 'struct',
            title: '牛人解盘主标题',
            groupName: '正文',
            content: content.answerTab,
        };

        return (
            <div className={`${styles.answer} clearfix`} onMouseEnter={this.handleOver} onMouseLeave={this.handleOver}>
                {/* <Tab title={title} /> */}
                <NoSSR>
                    {/* <Chip
                        id="10163"
                        type="static"
                        title="牛人解盘列表"
                        groupName="正文"
                        content={content.answerList}
                        position="relative">
                        <AnswerList />
                    </Chip> */}
                    {niuRenJiePan.length > 0 ? <DyNewsList content={niuRenJiePan} /> : ''}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Answer);
